import React from 'react';
import {Box, Link, List, useColorScheme} from "@mui/joy";
import {useNavigate} from "react-router-dom";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [pathname]);   

  return null;
};

const Footer = () => {
    const navigate = useNavigate();

    const {mode} = useColorScheme();

    return (
        <>
         <ScrollToTop />
    
        <Box sx = {{
            display: 'flex',
            flexDirection: 'row',
            borderTop: "1px solid",
            borderColor: "divider",
            paddingTop: "1rem",
            paddingBottom: "2rem",
            padding: "1rem",
            justifyContent: 'space-between',
            alignItems: "center"

        }}
             component="footer"
        >
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '.5rem',}}>
                {(mode === "light" || mode === "system") && (
                    <img alt={"Logo"} src={"/cdn/STARlogo.png"} width={"35px"} onClick={() => navigate("/")}
                         style={{cursor: 'pointer'}}/>
                )}
                {mode === "dark" && (
                    <img alt={"Logo"} src={"/cdn/DarkModeLogo.png"} width={"35px"} onClick={() => navigate("/")}
                         style={{cursor: 'pointer'}}/>
                )}
            </Box>

            <Box>
                <List sx={{display: 'flex', flexDirection: 'row', gap: '.5rem'}}>
                {/*<Link onClick={() => navigate("/blog")} color = {"neutral"} >Blog</Link>*/}
                    <Link onClick={() => navigate("/about")} color = {"neutral"} >About</Link>
                    <Link onClick={() => navigate("/methodology")} color = {"neutral"} >Methodology</Link>
                    <Link onClick={() => navigate("/terms-of-use")} color = {"neutral"} >Terms of Use</Link>
                    <Link onClick={() => navigate("/privacy-policy")} color = {"neutral"} >Privacy Policy</Link>
                    <Link href={"https://github.com/Surface-to-Air-Reports"} color = {"neutral"} >GitHub</Link>
                </List>
            </Box>
        </Box>

    </>
    )
}

export default Footer;
